import Icon from '../components/Icon.vue'

Icon.register({
  monument: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M368 448H16C7.2 448 0 455.2 0 464V496C0 504.8 7.2 512 16 512H368C376.8 512 384 504.8 384 496V464C384 455.2 376.8 448 368 448zM289.1 100.7A32-32 0 0 1 279.9 81.3L203.3 4.7C197.1-1.6 186.9-1.6 180.7 4.7L104.1 81.3A32-32 0 0 1 94.9 100.7L64 416H320L289.1 100.7zM240 307.2C240 313.6 233.6 320 227.2 320H156.8C150.4 320 144 313.6 144 307.2V268.8C144 262.4 150.4 256 156.8 256H227.2C233.6 256 240 262.4 240 268.8V307.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/monument.js
// module id = BGG+
// module chunks = 144